import type { DeepPartial } from '@luna/utils-ts';

import type { Orders } from '../../types/Orders';

export const ordersROFeatureConfig: DeepPartial<Orders> = {
    showDateHelpIcon: true,
    showFeesPriceNote: true,
    showOpenOrders: true,
    stickyHeaderMobile: true,
    typesNotToShowSellValidFromDate: ['BOND'],
};
